export default {"profile":"oKwWi","betDetails":"_79FCP","titleCell":"bYRer","titleHeading":"QoK7B","titleText":"jeFKS"};